"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMESHEET_BREAKDOWN_OPTIONAL_SLEEP_TIME_FIELDS = exports.TIMESHEET_BREAKDOWN_OPTIONAL_FIELDS = void 0;
exports.TIMESHEET_BREAKDOWN_OPTIONAL_FIELDS = {
    STATUS: "STATUS",
    SUBVENUE: "SUBVENUE",
    BREAK: "BREAK",
    TOTAL_PAY: "TOTAL_PAY",
    PAY_RATE: "PAY_RATE",
    TOTAL_CHARGE: "TOTAL_CHARGE",
    CHARGE_RATE: "CHARGE_RATE",
    PURCHASE_ORDER_NUMBER: "PURCHASE_ORDER_NUMBER",
};
exports.TIMESHEET_BREAKDOWN_OPTIONAL_SLEEP_TIME_FIELDS = {
    PLANNED_SLEEP_TIME: "PLANNED_SLEEP_TIME",
    PLANNED_SLEEP_TIME_TOTAL: "PLANNED_SLEEP_TIME_TOTAL",
    ACTUAL_SLEEP_TIME: "ACTUAL_SLEEP_TIME",
    ACTUAL_SLEEP_TIME_TOTAL: "ACTUAL_SLEEP_TIME_TOTAL",
    DISTURBED_SLEEP_TIME: "DISTURBED_SLEEP_TIME",
    DISTURBED_SLEEP_TIME_TOTAL: "DISTURBED_SLEEP_TIME_TOTAL",
};
